import React from 'react';
import { Button, List, ListItem, ListItemAvatar, ListItemText, Popover, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import noteStyles from './notes.module.css';
import { PopoverContent } from 'custom/components';
import { DateTimeFormat } from 'custom/constants';
import { dateTolocale } from 'utils/converter';

const NOTE_LENGTH = 50;

const AddNotes = (props) => {
  const { popup, anchorEl, closePopup, notes } = props;
  return (
    <div>
      <Popover
        open={popup === 'notes'}
        anchorEl={anchorEl}
        onClose={() => closePopup()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <PopoverContent className={styles.p2} sx={{ width: 300 }}>
          <div>
            <List sx={{
              maxHeight: 300,
              overflow: 'auto',
              marginRight: '-10px',
              paddingRIght: '10px',
              marginTop: '10px',
              width: '100%',
            }}>
              {notes?.length > 0 ? notes.map((note, index) => {
                let notes = note?.note;
                let user = note?.user;
                let created = note?.created ? note?.created : '';
                return(
                  <>
                    <ListItem key={index} className={`${noteStyles.historyListItem} ${noteStyles.noteListItem}`}>
                      <ListItemAvatar className={styles.mr2}>
                        <Typography variant='span' color='white' textTransform={'uppercase'} fontSize='10px' bgcolor={'rebeccapurple'} fontWeight={800} px={0.5} py={0.25} borderRadius={'4px'} lineHeight={'normal'} minWidth={'70px'} display={'block'} textAlign={'center'}>
                          {user?.role}
                        </Typography>
                      </ListItemAvatar>
                      <ListItemText
                        className={noteStyles.historyListText}
                        primaryTypographyProps={{
                          fontSize: 12,
                          color: 'primary.main',
                          fontWeight: 500,
                        }}
                        secondaryTypographyProps={{ fontSize: 12 }}
                        primary={<>
                          <span className={styles.overflowBreak}>{props.showMoreNote && props.showMoreNote[index] ? 
                            (notes?.length > NOTE_LENGTH ? notes?.slice(0, NOTE_LENGTH) + '...' : notes) : notes}</span>
                          {notes?.length > NOTE_LENGTH &&
                      <Button onClick={() => props.handleReadMore(index)} size='small' variant='text'>
                        <Typography fontStyle={'italic'} component='span' fontSize={12} color={'text.secondary'} textTransform={'capitalize'} >
                           &nbsp;Read {props.showMoreNote &&  props.showMoreNote[index] ? 'more' : 'less'}</Typography>
                      </Button>
                          }</>}
                        secondary={`${user?.first_name} ${user?.last_name} | ${dateTolocale(created, DateTimeFormat)?.toUpperCase()}`} />
                    </ListItem>
                  </>
                );}
                
              ) : null}
            </List>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
export default AddNotes;